// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"component---src-pages-en-js","223":"commons","293":"component---src-pages-index-js","773":"component---src-pages-zh-js"}[chunkId] + "-" + {"196":"e017505b1155991af92e","223":"98ac8a78d304c7b9cb61","293":"9266e8f78da2a6cfcb62","773":"83cefacc5df942184a71"}[chunkId] + ".js";
};